<template>
  <div id="selectelUploadModal" class="file-manager__modal modal fade" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Upload file (max size 500 Mb)</h4>
          <button type="button" class="close" data-dismiss="modal">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <div class="row">
              <div class="col-4">
                <label for="selectelUploadFile">File</label>
              </div>
              <div class="col-8">
                <input
                  id="selectelUploadFile"
                  ref="selectelUploadFile"
                  type="file"
                  multiple
                  @change="changeFile"
                >
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="row">
              <div class="col-4">
                <label for="selectelUploadPlace">Directory</label>
              </div>
              <div class="col-8">
                <select id="selectelUploadPlace" v-model="directory">
                  <option value="/">Root Folder</option>
                  <option value="new">New Folder</option>
                  <option v-for="folder in foldersList" :key="folder" :value="folder">
                    {{ folder }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div v-if="directory !== '/'" class="form-group">
            <div class="row">
              <div class="col-4">
                <label for="selectelUploadNewFolder">New Folder or Path</label>
              </div>
              <div class="col-8">
                <input
                  id="selectelUploadNewFolder"
                  v-model="newFolder"
                  type="text"
                  class="form-control"
                >
              </div>
            </div>
          </div>

          <div class="menu-builder__item-modal-error" style="color: red">{{ errorMessage }}</div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary save-btn" @click="upload">
            Save changes
            <span ref="saveBtnLoader" class="btn-loader" style="display: none;" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '../../../config';

export default {
  data: () => ({
    files: [],
    directory: '/',
    newFolder: '',
    errorMessage: '',
    foldersList: '',
  }),

  watch: {
    files() {
      this.errorMessage = '';
    },
  },

  mounted() {
    this.$root.$on('updateSelectelFolders', (foldersList) => {
      this.foldersList = foldersList;
    });

    $(this.$el).on('hidden.bs.modal', () => {
      this.$refs.selectelUploadFile.value = '';
      this.directory = '/';
      this.newFolder = '';

      this.errorMessage = '';
    });
  },

  methods: {
    changeFile(e) {
      if (e.currentTarget.files.length) {
        this.files = e.currentTarget.files;
      } else {
        this.files = [];
      }
    },
    upload() {
      if (this.files.length) {
        $(this.$refs.saveBtnLoader).show();
        let dir = '';
        if (this.directory === 'new') {
          dir = this.newFolder;
        } else if (this.directory !== '/') {
          dir = `${this.directory}/${this.newFolder}`;
        } else {
          dir = this.directory;
        }
        const { prefix, host } = this.$config.app_api;
        const token = JSON.parse(localStorage.getItem(config.tokenStorage.name));
        this.$store.dispatch('uploadManager/startUpload', {
          apiHost: host,
          apiPrefix: prefix,
          files: [...this.files],
          token,
          dir,
          is_public_file: true,
        });
        $(this.$refs.saveBtnLoader).hide();
        $(this.$el).modal('hide');
      } else {
        this.errorMessage = 'Please, upload files';
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// SelectelUpload.vue?843ff094